import Icon from '../Icon.vue'

Icon.register({
  'attach': {
    width: 12,
    height: 20,
    paths: [
      {
        d: 'M3.753 3.816a1.082 1.082 0 00-.003.077v10.444c0 .024 0 .046.002.069C3.809 15.845 5.02 17 6.5 17c1.48 0 2.691-1.155 2.748-2.594l.002-.069V6.083c0-.553-.41-1-.917-1-.507 0-.916.447-.916 1v8.216c0 .373-.43.701-.917.701-.488 0-.917-.328-.917-.701V3.96C5.583 2.879 6.611 2 7.875 2c1.264 0 2.292.879 2.292 1.96V14c0 2.206-1.645 4-3.667 4s-3.667-1.794-3.667-4v-4c0-.553-.41-1-.916-1C1.41 9 1 9.447 1 10v4c0 3.308 2.467 6 5.5 6s5.5-2.692 5.5-6V3.893c0-.025-.001-.052-.003-.077C11.918 1.699 10.1 0 7.875 0 5.65 0 3.83 1.699 3.753 3.816z'
      }
    ]
  }
})
